module.exports = __webpack_public_path__ + "static/media/agentic_hero_video.ee21af43.webm";